module.exports = {
          srcSet: __webpack_public_path__ + "images/2015-a43cfc4b43adc14f4f6882df1342ef18-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2015-b4fec42a7252ee1bef7aefc24c063262-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2015-a43cfc4b43adc14f4f6882df1342ef18-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2015-b4fec42a7252ee1bef7aefc24c063262-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2015-a43cfc4b43adc14f4f6882df1342ef18-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2015-a43cfc4b43adc14f4f6882df1342ef18-320.jpg"},
          
          width: 320,
          height: 251
        }